import { RotateCcw, Maximize2 } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ViewportControlsProps {
  zoom: number;
  onReset: () => void;
  onFit: () => void;
}

export function ViewportControls({ zoom, onReset, onFit }: ViewportControlsProps) {
  return (
    <div className="absolute bottom-4 right-4 flex items-center gap-1.5 bg-card/80 backdrop-blur-sm border border-border rounded-full px-2 py-1 shadow-md z-10">
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 rounded-full"
        onClick={onReset}
        title="Reset View"
      >
        <RotateCcw className="h-3.5 w-3.5" />
      </Button>
      <span className="text-xs font-mono text-muted-foreground min-w-[3ch] text-center tabular-nums">
        {Math.round(zoom * 100)}%
      </span>
      <Button
        variant="ghost"
        size="icon"
        className="h-7 w-7 rounded-full"
        onClick={onFit}
        title="Fit to Content"
      >
        <Maximize2 className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
